export default __webpack_public_path__ + "static/media/site_logo_light.7f827bf6.svg";